"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A = void 0;
var _react = _interopRequireDefault(require("react"));
var _A = require("./A.styles");
var _hooks = require("../../hooks");
var _hashString = require("../../utilities/hashString");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const A = props => {
  const {
    to,
    id,
    isDisabled,
    children,
    component = 'a',
    target = '_blank',
    onClick,
    category,
    label,
    optionalData,
    ariaLabel,
    role,
    ariaControls,
    ariaExpanded
  } = props;
  const Component = component;
  const styles = (0, _A.useStyles)(props);
  const {
    sendUiUsageEvent
  } = (0, _hooks.useCetEvents)();
  const handleClick = event => {
    if (!isDisabled) {
      if (category && label) {
        sendUiUsageEvent({
          category,
          label,
          optionalData
        });
      }
      if (onClick) {
        onClick(event);
      }
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
    to: to,
    href: component === 'a' ? to : undefined,
    target: target,
    onClick: handleClick,
    className: styles['cc-A'],
    "data-disabled": isDisabled,
    "aria-label": ariaLabel,
    role: role,
    "aria-controls": ariaControls,
    "aria-expanded": ariaExpanded,
    "data-testid": id || (0, _hashString.hashString)(to),
    children: children
  });
};
exports.A = A;